import {arrayToMap} from '../../atUtils'
import $ from 'jquery'
import _ from 'underscore'
import GroupType from '../../enums/GroupType'
import messageResource from '../../messageResource'
import {DateRangeSelectionQualifier, LeaveTypeSelectionQualifier, USERS_WITHOUT_GROUP_ID, WeekApprovalStatus} from 'constants'
import {DateFormat} from '../../date_format'
import DateRange from '../../DateRange'
import {departmentNameLower, tzgNameLower} from '../../util/pluralizeUtils'

export default class BaseReportParamsStringBuilder {

    DATE_FORMAT = window.SystemSettings.dateFormat

    constructor({data, dateFormat, userFormatter}) {

        this.users = data.users ? arrayToMap(data.users) : {}
        this.userGroups = data.userGroups ? arrayToMap(data.userGroups) : {}
        this.timeZoneGroups = data.timeZoneGroups ? arrayToMap(data.timeZoneGroups) : {}
        this.leaveTypesMap = data.leaveTypesMap || {}
        this.statuses = data.statuses

        this.groupFormatter = {
            format: (group) => group.name
        }

        this.userFormatter = userFormatter
        this.leaveTypesFormatter = {format: (leaveType) => leaveType.name}

        this.dateFormat = !!dateFormat ? dateFormat : this.DATE_FORMAT
    }

    getUser(id) {
        return this.users[id] ?
               this.users[id] :
               null
    }

    getFilteredUsers(ids) {
        let result = []

        ids.forEach(id => this.users[id] && result.push(this.users[id]))

        return result
    }

    getGroup(id) {
        return this.userGroups[id] ?
               this.userGroups[id] :
               null
    }

    getTimeZoneGroup(id) {
        return this.timeZoneGroups[id] ?
               this.timeZoneGroups[id] :
               null
    }

    getFilteredGroups(ids) {
        let result = []

        ids.forEach(id => (id !== USERS_WITHOUT_GROUP_ID && this.userGroups[id]) && result.push(this.userGroups[id]))

        return result
    }

    getFilteredTimeZoneGroups(ids) {
        let result = []

        ids.forEach(id => this.timeZoneGroups[id] && result.push(this.timeZoneGroups[id]))

        return result
    }

    getLeaveType(id) {
        return this.leaveTypesMap[id] ?
               this.leaveTypesMap[id] :
               null
    }

    getFilteredLeaveTypes = function(ids) {
        let result = []

        for (let i = 0; i < ids.length; i++) {
            if (this.getLeaveType(ids[i])) {
                result.push(this.getLeaveType(ids[i]))
            }
        }

        return result
    }

    joinStrings( col, separator, lastSeparator ) {
        if( col == null || col.length === 0 )
            return ""

        let res = col[0]

        for(let i = 1; i < col.length; i++) {
            if (i === col.length - 1)
                res += lastSeparator
            else
                res += separator
            res += col[i]
        }

        return res
    }

    getTitle( header, entities, formatter ) {
        let list = []
        const MAX_ENTITIES_IN_THE_TITLE = 12
        const BULLET_STRING = " - "
        const ELLIPSIS = "..."

        for(let i = 0; i < entities.length; i++) {
            list.push(formatter.format(entities[i]))
        }
        let result = header

        for(let i = 0; i < list.length; i++){
            if (i >= MAX_ENTITIES_IN_THE_TITLE)
                break

            result += "\n" + BULLET_STRING + list[i]
        }

        if( entities.length > MAX_ENTITIES_IN_THE_TITLE )
            result += "\n" + ELLIPSIS

        return result
    }

    convertToJSON(date)
    {
        if (_.isString(date)) {
            return date.parseJSONDate()
        }
        return date
    }

    getUserSelectionParamString(userSelection, getAllUsersMessage,) {
        if (userSelection.allUsers) {
            return getAllUsersMessage()
        } else {
            const groupType = userSelection.groupType
            let selectedUserWithoutUserGroup = false
            let users = this.getFilteredUsers(userSelection.selectedUsers)
            let groups = []

            if (userSelection.groupType === GroupType.USER_GROUP) {
                groups = this.getFilteredGroups(userSelection.selectedGroups)
                selectedUserWithoutUserGroup = $.inArray(USERS_WITHOUT_GROUP_ID, userSelection.selectedGroups) !== -1
            }
            if (userSelection.groupType === GroupType.TIME_ZONE_GROUP)
                groups = this.getFilteredTimeZoneGroups(userSelection.selectedGroups)


            users = this._convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection)

            if (userSelection.includeUserTeamOnly) {
                const includeTeamOnlyMessage = this._getIncludeUserTeamOnlyMessage(users)
                if (includeTeamOnlyMessage) {
                    return includeTeamOnlyMessage
                }
            }

            if (users.length === 0) {
                if (groups.length === 0 && !selectedUserWithoutUserGroup) {
                    return messageResource.getMessage("usersselector.no_users_selected")
                }
                if (groups.length === 1 && (!selectedUserWithoutUserGroup)) {
                    return messageResource.getMessage(
                        groupType === GroupType.USER_GROUP ? "common.User_Group" : "common.Time_Zone_Group")
                           + " \"" + this.groupFormatter.format(groups[0]) + "\""
                }
                if (groups.length === 0 && selectedUserWithoutUserGroup) {
                    return messageResource.getMessage("common.users_without_group")
                }
            }
            if (users.length === 1 && groups.length === 0 && (!selectedUserWithoutUserGroup)) {
                return this.userFormatter.format(users[0])
            }

            let res = []

            if (groups.length > 0) {
                const groupsText = groupType === GroupType.USER_GROUP ? departmentNameLower(groups.length) : tzgNameLower(groups.length)
                res.push(groups.length + " " + groupsText)
            }

            if (users.length > 0) {
                res.push(users.length === 1 ? messageResource.getMessage("saved_reports.user_selector.one_user")
                    : messageResource.getMessage("saved_reports.user_selector.multiple_users", [users.length.toString()]))
            }

            if (selectedUserWithoutUserGroup && this.userGroupsFeatureEnabled) {
                res.push(messageResource.getMessage("common.users_without_group"))
            }

            return this.joinStrings(res, ", ", " " + messageResource.getMessage("report.common.and_staff_delimiter") + " ")
        }
    }

    getUserSelectionDetailsString(userSelection) {
        let selectedUserWithoutUserGroup = false
        let users = this.getFilteredUsers(userSelection.selectedUsers)

        let groups = []
        if (userSelection.groupType === GroupType.USER_GROUP) {
            selectedUserWithoutUserGroup = $.inArray(USERS_WITHOUT_GROUP_ID, userSelection.selectedGroups) !== -1
            groups = this.getFilteredGroups(userSelection.selectedGroups)
        }

        if (userSelection.groupType === GroupType.TIME_ZONE_GROUP) {
            groups = this.getFilteredTimeZoneGroups(userSelection.selectedGroups)
        }
        users = this._convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection)
        if (!userSelection.allUsers && (users.length || groups.length) && !(users.length === 1 && groups.length === 0 && (!selectedUserWithoutUserGroup))) {
            let res = []
            if (users.length > 0) {
                res.push(this.getTitle(messageResource.getMessage("saved_reports.user_selector.title_header"), users, this.userFormatter))
            }
            if (groups.length > 0) {
                res.push(this.getTitle(
                    messageResource.getMessage(userSelection.groupType === GroupType.USER_GROUP ? "saved_reports.user_selector.title_header.user_groups" :
                                               "saved_reports.user_selector.title_header.time_zone_groups"), groups, this.groupFormatter))
            }

            if (selectedUserWithoutUserGroup && this.userGroupsFeatureEnabled) {
                res.push(messageResource.getMessage("common.users_without_group"))
            }

            return this.joinStrings(res, "\n", "\n")
        }
    }

    getUserSelectionClass(userSelection) {
        const CLASS_NAME = "users-filter"
        const ERROR_CLASS_NAME = "error-users-filter"

        let users = this.getFilteredUsers(userSelection.selectedUsers)
        let selectedUserWithoutUserGroup = false
        let groups = []
        if (userSelection.groupType === GroupType.USER_GROUP) {
            groups = this.getFilteredGroups(userSelection.selectedGroups)
            selectedUserWithoutUserGroup = $.inArray(USERS_WITHOUT_GROUP_ID, userSelection.selectedGroups) !== -1
        }
        if (userSelection.groupType === GroupType.TIME_ZONE_GROUP)
            groups = this.getFilteredTimeZoneGroups(userSelection.selectedGroups)

        users = this._convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection)


        if (!userSelection.allUsers && users.length === 0 && groups.length === 0 && !selectedUserWithoutUserGroup) {
            return CLASS_NAME + " " + ERROR_CLASS_NAME
        } else {
            return CLASS_NAME
        }
    }

    getLeaveTypeSelectionClass(leaveTypeSelection) {

        var CLASS_NAME = "leaves-filter"
        var ERROR_CLASS_NAME = "error-leaves-filter"

        if (leaveTypeSelection.qualifier === LeaveTypeSelectionQualifier.SELECTED) {
            var leaveTypes = this.getFilteredLeaveTypes(leaveTypeSelection.leaveTypes)

            if (leaveTypes.length === 0)
                return CLASS_NAME + " " + ERROR_CLASS_NAME
        }
        return CLASS_NAME
    }

    getLeaveTypeSelectionDetailsString(leaveTypeSelection) {

        if (leaveTypeSelection.qualifier !== LeaveTypeSelectionQualifier.ALL) {
            const leaveTypes = this.getFilteredLeaveTypes(leaveTypeSelection.leaveTypes)

            if (leaveTypes.length === 0 || leaveTypes.length === 1)
                return "" //error_class

            return this.getTitle(messageResource.getMessage("saved_reports.leaves_selector.title_header"), leaveTypes, this.leaveTypesFormatter)
        }
    }

    getLeaveTypeSelectionParamString(leaveTypeSelection) {

        if (leaveTypeSelection.qualifier === LeaveTypeSelectionQualifier.ALL)
            return messageResource.getMessage("leaves_selector.options.all_items")
        else {
            const leaveTypes = this.getFilteredLeaveTypes(leaveTypeSelection.leaveTypes)

            if (leaveTypes.length === 0)
                return messageResource.getMessage("report.leaves.no_leave_types") //error_class

            if (leaveTypes.length === 1)
                return messageResource.getMessage("saved_reports.leaves_selector.single_element",
                    [this.leaveTypesFormatter.format(leaveTypes[0])])

            return messageResource.getMessage("saved_reports.leaves_selector.multiple_types", [leaveTypes.length.toString()])
        }
    }

    getStatusesSelectionParamString(weekApprovalStatuses) {
        if (weekApprovalStatuses.length === 0) {
            return messageResource.getMessage("common.selector.statuses.no_tt_statuses")
        }

        const showApproved = _.contains(weekApprovalStatuses, WeekApprovalStatus.APPROVED)
        const showReady = _.contains(weekApprovalStatuses, WeekApprovalStatus.READY)
        const showNotReady = _.contains(weekApprovalStatuses, WeekApprovalStatus.NOT_READY)
        const showRejected = _.contains(weekApprovalStatuses, WeekApprovalStatus.REJECTED)

        if (showApproved && showReady && showNotReady && showRejected)
            return messageResource.getMessage("common.selector.statuses.all")

        let messages = []

        if (showApproved)
            messages.push(messageResource.getMessage("common.selector.statuses.approved"))

        if (showReady)
            messages.push(messageResource.getMessage("common.selector.statuses.ready"))

        if (showNotReady && showRejected)
            messages.push(messageResource.getMessage("common.selector.statuses.not_ready_and_rejected"))
        else if (showNotReady)
            messages.push(messageResource.getMessage("common.selector.statuses.not_ready"))
        else if (showRejected)
            messages.push(messageResource.getMessage("common.selector.statuses.rejected"))

        return messages.join(", ") + " " + messageResource.getMessage("common.selector.statuses.tt_statuses")
    }

    getDateRangeParamString(dateRangeSelection) {
        if (dateRangeSelection.qualifier !== DateRangeSelectionQualifier.CUSTOM) {
            return messageResource.getMessage(DateRangeStateUtil[dateRangeSelection.qualifier])
        }

        const fromDate = dateRangeSelection.fromDate.parseJSONDate()
        const toDate = dateRangeSelection.toDate.parseJSONDate()

        const dateRange = new DateRange(fromDate, toDate)
        if (dateRange.isOneDay())
            return new DateFormat(this.dateFormat).formatDate(fromDate) + ", " + Date.dayNames[fromDate.getDay()]

        return messageResource.getMessage("range.custom.pattern", [
            new DateFormat(this.dateFormat).formatDate(fromDate),
            new DateFormat(this.dateFormat).formatDate(toDate)
        ])
    }

    getDateRangeCSVString(dateRangeSelection) {
        const fromDate = this.convertToJSON(dateRangeSelection.fromDate)
        const toDate = this.convertToJSON(dateRangeSelection.toDate)

        const dateRange = new DateRange(fromDate, toDate)

        if (dateRange.isOneDay())
            return new DateFormat(this.dateFormat).formatDate(fromDate) + ", " + Date.dayNames[fromDate.getDay()]

        return messageResource.getMessage("range.custom.detailed_string", [
            new DateFormat(this.dateFormat).formatDate(fromDate) + ", " + Date.dayNames[fromDate.getDay()],
            new DateFormat(this.dateFormat).formatDate(toDate) + ", " + Date.dayNames[toDate.getDay()]
        ])
    }

    getDateRangeDetailsString(dateRangeSelection) {
        if (dateRangeSelection.qualifier === DateRangeSelectionQualifier.CUSTOM)
            return ""

        return messageResource.getMessage("range.custom.pattern", [
            new DateFormat(this.dateFormat).formatDate(dateRangeSelection.fromDate.parseJSONDate()),
            new DateFormat(this.dateFormat).formatDate(dateRangeSelection.toDate.parseJSONDate())
        ])
    }

    getBalancesParamString(enabledPTO, enabledSick) {
        if (enabledPTO && enabledSick)
            return messageResource.getMessage("common.leave.reports.pdf.header.balances")

        if (enabledPTO)
            return messageResource.getMessage("common.leave.reports.pdf.header.pto")

        if (enabledSick)
            return messageResource.getMessage("common.leave.reports.pdf.header.sick")

        return null
    }

    _convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection) {
        // abstract
    }

    _getIncludeUserTeamOnlyMessage(users) {
        // abstract
    }


}


// WEBPACK FOOTER //
// ./web/js/reports/reportParamsStringBuilder/BaseReportParamsStringBuilder.js